import axios from 'axios';

class ConfigService{

  constructor() {
    this.$axios = axios;
  }

  getConfigServiceList(params,callback){
    this.$axios({
      method: 'get',
      url:`/api/cameraLivePostion/all`,
      // params: {

      // }
    }).then(function (res) {
      if (typeof (callback) == "function") callback(res.data)
    }).catch(function (error) {
      console.log(error);
    });
  }
  addServer(param, callback){
    this.$axios({
      method: 'post',
      url:`/api/cameraLivePostion/add`,
      data: param
    }).then(function (res) {
      if (typeof (callback) == "function") callback(res.data)
    }).catch(function (error) {
      console.log(error);
    });
  }

  editServer(param, callback){
    this.$axios({
      method: 'post',
      url:`/api/cameraLivePostion/update`,
      data: param
    }).then(function (res) {
      if (typeof (callback) == "function") callback(res.data)
    }).catch(function (error) {
      console.log(error);
    });
  }


  delete(id, callback) {
    this.$axios({
      method: 'delete',
      url:`/api/cameraLivePostion/delete`,
      params: {
        id: id
      }
    }).then(function (res) {
      if (typeof (callback) == "function") callback(res.data)
    }).catch(function (error) {
      console.log(error);
    });
  }


}

export default ConfigService;



// WEBPACK FOOTER //
// ./src/components/service/ConfigService.js